export default __webpack_public_path__ + "static/media/samuel-regan-asante.1dd6acb3.png";